import React from "react";
export const endpoints = {
    senior_pincode : 'seniorpremiumcalculator/udaanapi/quoteservice/getLocationDetailsByPincode/',
    pincode_for_rest:"sellonlineprimeappformservice/udaanapi/appformservice/getLocationDetailsByPincode/",
    prohelath_pincode:'sellonline/v1/getLocationDetailsByPincode/',
    lifetime_pincode: 'sellonline/v1/location-details/',
    sarvah_pincode: 'sellonline/v1/location-details/'
    //https://uat-online.api.manipalcigna.com/api/sellonline/v1/location-details/711313/app/prime
}
